
(() => {
  function initialize(root = document) {
    const images = root.querySelectorAll(
      'product-modal .product-media-modal__content > img'
    );

    images.forEach((image) => {
      if (image.dataset.pinchReady) return;
      image.dataset.pinchReady = 'true';

      const container = image.parentElement;
      const modal = image.closest('product-modal');
      const pointers = new Map();

      let scale = 1;
      let x = 0;
      let y = 0;
      let gesture = null;

      const distance = (a, b) =>
        Math.hypot(a.x - b.x, a.y - b.y);

      const midpoint = (a, b) => ({
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2
      });

      const clamp = (value, min, max) =>
        Math.max(min, Math.min(max, value));

      function render() {
        const maxX = Math.max(
          0,
          (image.clientWidth * scale - container.clientWidth) / 2
        );

        const maxY = Math.max(
          0,
          (image.clientHeight * scale - container.clientHeight) / 2
        );

        x = clamp(x, -maxX, maxX);
        y = clamp(y, -maxY, maxY);

        image.style.transform =
          `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
      }

      function reset() {
        scale = 1;
        x = 0;
        y = 0;
        image.style.transform = '';
      }

      function beginGesture() {
        const points = [...pointers.values()];

        if (points.length === 1) {
          gesture = {
            type: 'pan',
            point: points[0],
            x, y
          };
        } else if (points.length === 2) {
          const rect = image.getBoundingClientRect();

          gesture = {
            type: 'pinch',
            distance: Math.max(1, distance(...points)),
            middle: midpoint(...points),
            center: {
              x: rect.left + rect.width / 2,
              y: rect.top + rect.height / 2
            },
            scale, x, y
          };
        } else {
          gesture = null;
        }
      }

      image.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch') return;
        if (window.innerWidth >= 750) return;

        pointers.set(event.pointerId, {
          x: event.clientX,
          y: event.clientY
        });

        image.setPointerCapture(event.pointerId);
        beginGesture();
      });

      image.addEventListener('pointermove', (event) => {
        if (!pointers.has(event.pointerId)) return;

        pointers.set(event.pointerId, {
          x: event.clientX,
          y: event.clientY
        });

        const points = [...pointers.values()];

        if (points.length === 2 && gesture?.type === 'pinch') {
          const factor = distance(...points) / gesture.distance;

          scale = clamp(gesture.scale * factor, 1, 4);

          const middle = midpoint(...points);
          const ratio = scale / gesture.scale;

          x = gesture.x +
            (middle.x - gesture.middle.x) +
            (gesture.middle.x - gesture.center.x) * (1 - ratio);

          y = gesture.y +
            (middle.y - gesture.middle.y) +
            (gesture.middle.y - gesture.center.y) * (1 - ratio);

          render();
        } else if (
          points.length === 1 &&
          gesture?.type === 'pan' &&
          scale > 1
        ) {
          x = gesture.x + points[0].x - gesture.point.x;
          y = gesture.y + points[0].y - gesture.point.y;
          render();
        }
      });

      function endPointer(event) {
        if (!pointers.has(event.pointerId)) return;

        pointers.delete(event.pointerId);
        beginGesture();

        if (scale <= 1) reset();
      }

      image.addEventListener('pointerup', endPointer);
      image.addEventListener('pointercancel', endPointer);

      new MutationObserver(() => {
        if (!modal.hasAttribute('open')) {
          pointers.clear();
          gesture = null;
          reset();
        }
      }).observe(modal, {
        attributes: true,
        attributeFilter: ['open']
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
